import { render } from "./Basics.vue?vue&type=template&id=5b44c0b8"
import script from "./Basics.vue?vue&type=script&lang=js"
export * from "./Basics.vue?vue&type=script&lang=js"

import "./Basics.vue?vue&type=style&index=0&id=5b44c0b8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__